var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.alertInfo.text !== "Request aborted"
    ? _c("div", { staticClass: "user-alert" }, [
        _c(
          "div",
          {
            staticClass: "alertWrap",
            staticStyle: {
              "box-sizing": "border-box",
              position: "fixed",
              top: "50%",
              left: "50%",
              "z-index": "100001",
              margin: "-60px 0 0 -106px",
              padding: "0 20px",
              width: "212px",
              "min-height": "140px",
              "font-size": "14px",
              background: "#fff",
              "border-radius": "4px",
              "box-shadow": "0 0 8px #ccc"
            }
          },
          [
            _c("div", [
              _c("img", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.alertInfo.type === "success",
                    expression: "alertInfo.type === 'success'"
                  }
                ],
                staticStyle: {
                  position: "absolute",
                  top: "-36px",
                  left: "45px"
                },
                attrs: {
                  src: require("../assets/imgs/common/alertSuccess.png"),
                  alt: "成功提示"
                }
              }),
              _vm._v(" "),
              _c("img", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.alertInfo.type === "error",
                    expression: "alertInfo.type === 'error'"
                  }
                ],
                staticStyle: {
                  position: "absolute",
                  top: "-36px",
                  left: "45px"
                },
                attrs: {
                  src: require("../assets/imgs/common/alertError.png"),
                  alt: "成功提示"
                }
              }),
              _vm._v(" "),
              _c("img", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.alertInfo.type === "info",
                    expression: "alertInfo.type === 'info'"
                  }
                ],
                staticStyle: {
                  position: "absolute",
                  top: "-36px",
                  left: "45px"
                },
                attrs: {
                  src: require("../assets/imgs/common/alertWarning.png"),
                  alt: "成功提示"
                }
              }),
              _vm._v(" "),
              _vm.alertInfo.imgUrl
                ? _c("img", {
                    staticStyle: {
                      position: "absolute",
                      top: "-36px",
                      left: "45px"
                    },
                    attrs: { src: _vm.alertInfo.imgUrl, alt: "成功提示" }
                  })
                : _vm._e()
            ]),
            _vm._v(" "),
            _c(
              "p",
              {
                staticStyle: {
                  "text-align": "center",
                  "font-size": "14px",
                  color: "#555555",
                  "margin-top": "50px"
                }
              },
              [_vm._v(_vm._s(_vm.alertInfo.text))]
            )
          ]
        ),
        _vm._v(" "),
        _c("div", {
          staticClass: "alertMark",
          staticStyle: {
            position: "fixed",
            top: "0",
            left: "0",
            bottom: "0",
            "z-index": "100000",
            width: "100%",
            height: "100%",
            background: "rgba(0, 0, 0, 0.5)"
          }
        })
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }